import { Container, Sprite, TextStyle, Text } from "pixi.js";
import { RaidResourcePackage } from "../resources/RaidResourcePackage";
import { RewardHint } from "./RewardHint";
import { gsap } from "gsap";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { RaidTutorialResourcePackage } from "../resources/RaidTutorialResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
type Timeline = gsap.core.Timeline;

export class RewardContainer extends Container {
    private readonly raidResources: RaidResourcePackage;
    private readonly tutorialResources: RaidTutorialResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly isFirstShow: boolean;
    private hintContainer: RewardHint;

    public constructor(
        raidResources: RaidResourcePackage,
        tutorialResources: RaidTutorialResourcePackage,
        commonResources: CommonResourcesPackage,
        rewardValue: number,
        icon: Container,
        isFirstShow: boolean
    ) {
        super();
        this.raidResources = raidResources;
        this.tutorialResources = tutorialResources;
        this.commonResources = commonResources;
        this.isFirstShow = isFirstShow;
        this.build(rewardValue, icon);
        this.once("added", this.hideToolTip.bind(this));
    }

    private build(rewardCount: number, icon: Container): void {
        const youWon = new Sprite(this.raidResources.assets_views_raid_ui_you_won_text_png);
        youWon.anchor.set(0.5, 0.5);
        this.addChild(youWon);
        const containerIcon = icon;
        containerIcon.position.set(youWon.x, youWon.y - youWon.height * 0.5 - containerIcon.height * 0.45);
        this.addChild(containerIcon);
        const rewardValue = new Text(StringFormatExtention.formatWithComma(rewardCount), new RewardValueTextStyle());
        rewardValue.anchor.set(0.5, 0.5);
        rewardValue.position.set(youWon.x - 80, youWon.y + rewardValue.height * 0.6);
        this.addChild(rewardValue);
        const rewardIcon = new Sprite(this.raidResources.assets_views_raid_ui_coin_icon_png);
        rewardIcon.anchor.set(0.5, 0.5);
        rewardIcon.scale.set(1.2, 1.2);
        rewardIcon.position.set(rewardValue.position.x + rewardValue.width * 0.5 + rewardIcon.width * 0.6, rewardValue.position.y - 10);
        this.addChild(rewardIcon);
        if (this.isFirstShow) {
            this.hintContainer = new RewardHint(this.tutorialResources, this.commonResources);
            this.hintContainer.position.set(rewardValue.x + rewardIcon.width * 0.5, rewardValue.y - 25);
            this.addChild(this.hintContainer);
        }
    }

    public hideToolTip(): void {
        if (this.isFirstShow) {
            this.hintContainer.visible = false;
        }
    }

    public getShowHintTween(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.set(this.hintContainer, { visible: true });
        animationTimeLine.fromTo(this.hintContainer.scale, { x: 2, y: 2 }, { x: 1, y: 1, duration: 0.2 });
        animationTimeLine.fromTo(this.hintContainer, { alpha: 0 }, { alpha: 1, duration: 0.2 }, "<");
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }

    public getHideHintTween(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.fromTo(this.hintContainer.scale, { x: 1, y: 1 }, { x: 2, y: 2, duration: 0.2 });
        animationTimeLine.fromTo(this.hintContainer, { alpha: 1 }, { alpha: 0, duration: 0.2 }, "<");
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }
}

class RewardValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#feca3b",
                "#f49801"
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 155,
            stroke: "#ffffff",
            letterSpacing: -3,
            strokeThickness: 10
        }));
    }
}
